export const REGISTER_FORM_LINK = {
  es: 'https://www.ontruck.com/es/empresas/registro',
  fr: 'https://www.ontruck.com/fr/expediteurs/inscription',
};
